export const SkeletonBaseColor = '#f0f0f0';
